/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanResponse } from "../models/BooleanResponse";
import type { CreateRegulatoryRunRequest } from "../models/CreateRegulatoryRunRequest";
import type { Response_list_definitions_public_v1_regulation_FragranceCheckResult__ } from "../models/Response_list_definitions_public_v1_regulation_FragranceCheckResult__";
import type { Response_list_definitions_public_v1_regulation_RegulationGroup__ } from "../models/Response_list_definitions_public_v1_regulation_RegulationGroup__";
import type { Response_list_definitions_public_v1_regulation_RegulationsCheckResult__ } from "../models/Response_list_definitions_public_v1_regulation_RegulationsCheckResult__";
import type { Response_list_definitions_public_v1_regulation_RegulatoryRunListing__ } from "../models/Response_list_definitions_public_v1_regulation_RegulatoryRunListing__";
import type { RunFragranceCheckRequest } from "../models/RunFragranceCheckRequest";
import type { RunRegulatoryCheckRequest } from "../models/RunRegulatoryCheckRequest";
import type { UpdateRegulatoryRunRequest } from "../models/UpdateRegulatoryRunRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class RegulationService {
  /**
   * Get Regulation Groups
   * @returns Response_list_definitions_public_v1_regulation_RegulationGroup__ Successful Response
   * @throws ApiError
   */
  public static regulationGetRegulationGroups(): CancelablePromise<Response_list_definitions_public_v1_regulation_RegulationGroup__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/regulations/groups",
    });
  }
  /**
   * Check Regulations
   * @param requestBody
   * @returns Response_list_definitions_public_v1_regulation_RegulationsCheckResult__ Successful Response
   * @throws ApiError
   */
  public static regulationCheckRegulations(
    requestBody: RunRegulatoryCheckRequest
  ): CancelablePromise<Response_list_definitions_public_v1_regulation_RegulationsCheckResult__> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/regulations/check",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Check Fragrances
   * @param requestBody
   * @returns Response_list_definitions_public_v1_regulation_FragranceCheckResult__ Successful Response
   * @throws ApiError
   */
  public static regulationCheckFragrances(
    requestBody: RunFragranceCheckRequest
  ): CancelablePromise<Response_list_definitions_public_v1_regulation_FragranceCheckResult__> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/regulations/fragrance",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * List Regulatory Runs
   * @returns Response_list_definitions_public_v1_regulation_RegulatoryRunListing__ Successful Response
   * @throws ApiError
   */
  public static regulationListRegulatoryRuns(): CancelablePromise<Response_list_definitions_public_v1_regulation_RegulatoryRunListing__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/regulations/runs",
    });
  }
  /**
   * Create Regulatory Run
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static regulationCreateRegulatoryRun(
    requestBody: CreateRegulatoryRunRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/regulations/runs",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Regulatory Run
   * @param regulatoryRunId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static regulationUpdateRegulatoryRun(
    regulatoryRunId: string,
    requestBody: UpdateRegulatoryRunRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/regulations/runs/{regulatory_run_id}",
      path: {
        regulatory_run_id: regulatoryRunId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
